module.exports = __webpack_public_path__ + "static/media/beach.a14747d2.jpg";